/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';

import BaseExhibitorsPage from '@bottlebooks/gatsby-theme-event/src/components/ExhibitorsPage/ExhibitorsPage';

export * from '@bottlebooks/gatsby-theme-event/src/components/ExhibitorsPage/ExhibitorsPage';

export default function ExhibitorsPage({
  exhibitors,
  event,
  collectionId,
  locale,
  location,
  ...rest
}) {
  return (
    <BaseExhibitorsPage
      exhibitors={exhibitors}
      event={event}
      collectionId={collectionId}
      locale={locale}
      location={location}
      {...rest}
    />
  );
}
